<template>
    <b-card>
        <PreviewModal ref="preview_modal"></PreviewModal>
        <h3>Files</h3>
        <div v-if="files.length > 0">
            <div v-for="(file, index) in files" :key="index" class="mb-2">
                <i class="fa fa-download text-primary"></i>
                <el-tooltip :content="file.original_file_name || file.original_filename">
                    <a href="javascript:void(0)" v-if="$route.query.source_type === 'PMP'" class="ml-1" @click="$refs.preview_modal.preview(
                        file.attach_file_path || file.path,
                        file.original_file_name || file.original_filename
                    )">{{ file.original_file_name || file.original_filename | shortenText(30) }}</a>
                    <a v-else :href="file.url" target="_blank" class="ml-1">
                        {{ file.original_file_name || file.original_filename | shortenText(30) }}
                    </a>
                </el-tooltip>
            </div>
        </div>
        <div v-else>N/A</div>
    </b-card>
</template>
<script>
import { Tooltip } from 'element-ui'
import PreviewModal  from '@/components/Modal/PreviewModal'

export default {
    props: ['files'],
    components: {
        PreviewModal,
        [Tooltip.name]: Tooltip,
    }
}
</script>